/* unplugin-vue-components disabled */import { render } from "./starmap.vue?vue&type=template&id=8c89efbe&scoped=true"
import script from "./starmap.vue?vue&type=script&lang=js"
export * from "./starmap.vue?vue&type=script&lang=js"

import "./starmap.vue?vue&type=style&index=0&id=8c89efbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c89efbe"]])

export default __exports__